import { memberZoneApi } from 'api';
import { MemberCodeOutput } from 'pco-product-service-internal-consumer';

export const revokeMemberCode = async (partnerNumber: string): Promise<MemberCodeOutput> => {
  return await memberZoneApi.revokeMemberCode({ partnerUid: partnerNumber });
};
